export { EnrichedMarkdownText } from "react-native-enriched-markdown";
export type {
  EnrichedMarkdownTextInputInstance,
  EnrichedMarkdownTextInputProps,
  MarkdownTextInputStyle,
} from "react-native-enriched-markdown/lib/typescript/src/EnrichedMarkdownTextInput";
export { EnrichedMarkdownTextInput } from "./enriched-markdown-text-input-web.tsx";
